import React from "react";
import SuccessCasesCard from "../../components/successCases/SuccessCasesCardNew";

const SuccessCasesSection = () => {
  return (
    <div className="bg-white py-5">
      <SuccessCasesCard />
    </div>
  );
};
export default SuccessCasesSection;
